"use strict";

import React from 'react';
import Icon from "./Icon";

const FormRequiredLegend = (props) => {
    return (
        <p className="required">
            Required fields are marked with <Icon name="required" className="icon--required-color" />
        </p>
    );
};

export default FormRequiredLegend;
